import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { Test } from '../test';
import { TestService } from '../../../services/test.service';
import { WardService } from '../../../services/ward.service';
import { DoctorService } from '../../../services/doctor.service';
import { OrderEntryService } from '../../../services/order-entry.service';

import { NgbModal, NgbModalConfig, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, DialogPosition  } from '@angular/material/dialog';

import { LabelsDialog } from './modals/labels.component'
import { SelectionDialog } from '../../utils/group-selection/selection.component';
import { UserService } from 'src/app/services/user.service';
import { TestsDialog } from './modals/tests.component';
import { NotesDialog } from './modals/notes.component';
import { LabelsInputDialog } from './modals/labels-input.component';

@Component({
  selector: 'app-order-entry',
  templateUrl: './order-entry.component.html',
  styleUrls: ['./order-entry.component.css'],
  providers: [NgbModalConfig, NgbModal, NgbTooltip]
})
export class OrderEntryComponent implements OnInit {

  constructor(private fb: FormBuilder,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private testService: TestService,
    private wardService: WardService,
    private doctorService: DoctorService,
    private orderEntryService: OrderEntryService,
    public dialog: MatDialog,
    private userService: UserService) {

      this.createForm();
      // customize default values of modals used by this component tree
      config.backdrop = 'static';
      config.keyboard = false;
      this.prioritiesLevel = this.orderEntryService.getPriorityLevel();


      this.user = this.userService.getUser();
      this.group = this.userService.getActiveGroup('order-entry');
      if( this.group == null) {
        this.dialog.open(SelectionDialog, {
          data: {groupType: 'order-entry'},
          width: '40%',
          disableClose: true 
        });      
        
      } else{
        this.updateData();
      }

      this.userService.updateUser().subscribe(
        (newUser) => {
          this.user = newUser
          this.group = this.userService.getActiveGroup('order-entry');
          this.updateData();

        }
      )

      this.filter.valueChanges.pipe(debounceTime(300)).subscribe(
        (term) => {
          term = term?.toLowerCase();
          if(term != ''){
            this.filteredTests = this.tests.filter(
              test => {
                
                return(
                  test.id?.toLowerCase().includes(term) ||
                  test.description?.toLowerCase().includes(term) ||
                  test.specimenDescription?.toLowerCase().includes(term)
                )
              }
              
            );
          }
          
        }     
      )

  }

  clear(){
    this.filter.setValue('')
  }
  user;
  group;
  updateData() {
    this.wards = this.group.wards.sort((a, b) => (a.wardDescription > b.wardDescription) ? 1 : ((b.wardDescription > a.wardDescription) ? -1 : 0));
    this.newOrder.get('ward').setValue('')
    this.formTest.clear();
    //this.newOrder.get('tariffId').setValue(this.group.tariffId)
  }

  get orderPatientValid() {

    if(! this.newOrder.get('patient').valid){
      this.newOrder.get('externalOrderId').disable();
      this.newOrder.get('orderDate').disable();
      this.newOrder.get('priorityLevel').disable();
      this.newOrder.get('doctor').disable();
      this.newOrder.get('ward').disable();
      this.newOrder.get('ente').disable();
    }else{
      this.newOrder.get('externalOrderId').enable();
      this.newOrder.get('orderDate').enable();
      this.newOrder.get('priorityLevel').enable();
      this.newOrder.get('doctor').enable();
      this.newOrder.get('ward').enable();

      if(!this.newOrder.get('orderDate').value){
        this.newOrder.get('orderDate').setValue(new Date().toLocaleString('es-AR'));
      }
    }
    

    return this.newOrder.get('patient').valid;
  }

  get ward() {
    return this.newOrder.get('ward').value;
  }

  get orderInfoValid(){
    let isValid = this.newOrder.get('ward').valid && this.newOrder.get('priorityLevel').valid;

    if(! isValid){
      this.samplesForm.get('samples').disable()
    }else{
      this.samplesForm.get('samples').enable()

    }
    return isValid;
  }

  get formTest() {
    return this.newOrder.controls.tests as FormArray;
  }

  newOrder: FormGroup;
  samplesForm: FormGroup;
  wards: any;
  prioritiesLevel: any;
  entes;
  // typeahead test
  searching = false;
  searchFailed = false;

  // typeahead doctor
  searchingDoctor = false;
  searchFailedDoctor = false;

  profiles;
  sections;

  ngOnInit(): void {
    this.testService.getAllTests().then(
      data => {
        this.tests = data;
        this.sections = [... new Set(data.map(test => test.sectionDescription))]
      }
    )
    this.testService.getAllProfiles().then(
      data => this.profiles = data
    )
  }

  openModal(content) {
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  patientChangeEvent(patient) {
    this.newOrder.patchValue({
      patient
    });
  }

  formatMatches = (value: Test) => {
    return value.id + ' - ' + value.specimenId;
  }

  selectTest($event, testInput) {
    this.addTest($event.option.value);
    testInput.value = '';
  }

  tests;

  searchTest = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.testService.getTest(term).then(
          (tests) => {
            this.tests = tests;
            this.searchFailed = tests.length === 0;
          }
        ).catch(
          () => {
            this.searchFailed = true;
            return of([]);
          }
        )
      ),
      tap(() => this.searching = false)
    )

  formatMatchesDoctor = (value: any) => value ? value.nameSurname + ' - ' + value.nationalId : '';
  searchDoctor = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searchingDoctor = true),
      switchMap(term =>
        this.doctorService.getDoctors(term).pipe(
          tap((doctors) => {
            this.searchFailedDoctor = doctors.length === 0;
          }),
          catchError(() => {
            this.searchFailedDoctor = true;
            return of([]);
          }))
      ),
      tap(() => this.searchingDoctor = false)
    )

  addTest(test: Test) {
    const search = this.formTest.controls.findIndex((t) => t.value.id === test.id);
    if (search === -1) {
      this.formTest.push(this.fb.group(test));
    }
  }

  removeTest(i) {
    this.formTest.removeAt(i);
  }

  verifyAndSendOrder() {
    if (this.samplesForm.valid && this.newOrder.valid) {
      const samples = this.samplesForm.get('samples').value;
      this.newOrder.addControl('samples', this.fb.array(samples));
      this.orderEntryService.sendOrder(this.newOrder.value).subscribe((resp) => {
        if (resp !== 0) {
          this.clearForm();
          //this.closeModal();
          //alert('Su solicitud se ha cargado correctamente \n Su número de solicitud es: ' + resp);
        }
      });
    }
  }

  // submit form para calcular muestras
  sampleCalculation() {
    /*console.log('CALCULANDO MUESTRAS', this.newOrder.value);
    this.orderEntryService.samplesCalculation(this.newOrder.value).subscribe((resp) => {
      this.samplesForm.reset();
      this.samplesForm = this.fb.group({
        samples: new FormArray([])
      });
      this.setSamplesForm(resp);
      // this.newOrder.addControl('samples', this.samplesForm);
      this.openModal(samplesModal);
      console.log(resp);
    });*/

    this.orderEntryService.samplesCalculation(this.newOrder.value).subscribe((resp) => {
      this.samplesForm.reset();
      this.samplesForm = this.fb.group({
        samples: new FormArray([])
      });
      this.setSamplesForm(resp);
      // this.newOrder.addControl('samples', this.samplesForm);

      const ref = this.dialog.open(LabelsInputDialog, {
        //width: '50%',
        data: { samples: resp, sampleCheck : this.group.sampleCheck }
      });

      ref.afterClosed().subscribe(
        (samples) => {
          //this.clearForm();
          this.newOrder.addControl('samples', this.fb.array(samples));
          //this.newOrder.setControl('samples',  this.fb.array(samples))
          this.orderEntryService.sendOrder(this.newOrder.value).subscribe((resp) => {
            if (resp !== 0) {
              this.clearForm();
              //this.closeModal();
              //alert('Su solicitud se ha cargado correctamente \n Su número de solicitud es: ' + resp);
            }
          });
        }
      )
    });


  }

  saveOrder() {
    if (!this.isValidFormForSave()) {
      this.orderEntryService.saveOrder(this.newOrder.value).subscribe((resp) => {
        this.clearForm();
        alert('Su solucitud se guardo correctamente');
      },
        (error) => {
          alert('No se pudo guardar su solicitud');
        });
    }
  }

  createForm() {
    this.newOrder = this.fb.group({
      externalOrderId: new FormControl(),
      orderDate: ['', Validators.required],
      priorityLevel: ['', Validators.required],
      noteSector: [''],
      doctor: [null, Validators.required],
      ward: ['', Validators.required],
      ente: new FormControl({ value: '', disabled: true }),
      tests: new FormArray([], Validators.required),
      tariffId: [-1],
      patient: this.fb.group({
        id: [''],
        name: ['', Validators.required],
        surname: ['', Validators.required],
        birthdate: [''],
        fiscalCode: ['', Validators.required],
        healthCode: ['',],
        sex: [''],
        phone: [''],
        email: [''],
        address: [''],
      }),
    });
    this.samplesForm = this.fb.group({
      samples: new FormArray([])
    });
  }
  setSamplesForm(samples: Array<any>) {
    const control = this.samplesForm.controls.samples as FormArray;
    samples.forEach(sample => {
      control.push(this.fb.group({
        sampleProgressive: [sample.sampleProgressive,],
        containerId: [sample.containerId,],
        labelId: ['', Validators.required],
        tests: [sample.tests,],
        zoneId: [sample.zoneId,]
      }));
    });
  }
  loadEntes() {
    const ward = this.newOrder.get('ward').value;
    if (ward) {
      this.wardService.getEntes(ward).subscribe((resp) => {
        if (resp.length > 0) {
          this.entes = resp;
          this.newOrder.get('ente').enable();
        } else {
          this.entes = [];
          this.newOrder.get('ente').disable();
        }

      });
    }
  }
  trackByFn(index, item) {
    return index;
  }

  testFromSamples(tests: any) {
    const testArr = tests.map(test => test.id);
    return testArr.join('\n');
  }
  clearForm() {
    const tests = this.newOrder.get('tests') as FormArray;
    tests.clear();
    this.newOrder.removeControl('samples')
    this.newOrder.reset();
    this.newOrder.get('noteSector').setValue('')
  }
  isValidFormForSave() {
    return this.newOrder.get('ward').invalid || this.newOrder.get('priorityLevel').invalid;
  }

  sendOrder() {
    this.orderEntryService.createOrder(this.newOrder.value).subscribe((resp) => {
      // this.newOrder.addControl('samples', this.samplesForm);
      console.log(resp);
      const ref = this.dialog.open(LabelsDialog, {
        width: '50%',
        data: { samples: resp }
      });

      ref.afterClosed().subscribe(
        () => {
          this.clearForm();
        }
      )
    });
  }

  searchTests = false;

  showTestsDialog(){
    /*this.testService.getAllTestsFiltered(this.newOrder.value.ward.serviceType, this.newOrder.value.priorityLevel).then(
      data => this.dialog.open(TestsDialog, {
        width: '50%',
        data: data
      })
    )*/

    const ref = this.dialog.open(TestsDialog, {
      width: '50%',
    });

    ref.afterClosed().subscribe(
      data => {
        if(data.length >= 1){
          data.forEach(element => {
            this.addTest(element);
          });
        }
      }
    )
    
  }

  filteredTests = new Array();

  filterTests(section){
  
    if(section == "all"){
      this.filteredTests = this.tests
    }else {
      this.filteredTests = this.tests.filter(
        test => test.sectionDescription == section
      );
    }
    
  }

  filter = new FormControl();

  searchByCode(input){
    this.testService.getTestByCode(input.value).then( // HAY QUE FILTRAR
      result => {
        if(result.length == 0){
          this.searchFailed = true;
          setTimeout(()=> this.searchFailed = false, 1500)
        }
        if(result.length == 1){
          this.addTest(result[0])
        } // VER MULTIMATERIAL
        input.value = '';

      }
    )
  }

  addNotes(event){

    const dialogPosition: DialogPosition = {
      top: event.y + 'px',
      left: (event.x-500) + 'px'
    };
  
    const ref = this.dialog.open(NotesDialog, {
      width: '500px',
      data: this.newOrder.get('noteSector').value,
      position: dialogPosition,
    });

    ref.afterClosed().subscribe(
      data => {
        if(data != null && data != undefined)
        this.newOrder.get('noteSector').setValue(data)
      }
    )

  }


}
